import { useEffect } from 'react';
import { View } from 'react-native';
import Animated, {
  Extrapolation,
  interpolate,
  type SharedValue,
  useAnimatedStyle,
  useSharedValue,
  withTiming
} from 'react-native-reanimated';

type PaginationCompProps = {
  index: number;
  animatedIndex: SharedValue<number>; // or currentIndex: number if not animated
};

export function PaginationComp({ index, animatedIndex }: PaginationCompProps) {
  const animatedDotStyle = useAnimatedStyle(() => {
    const widthAnimation = interpolate(
      animatedIndex.value,
      [index - 1, index, index + 1],
      [10, 20, 10],
      Extrapolation.CLAMP
    );

    const opacityAnimation = interpolate(
      animatedIndex.value,
      [index - 1, index, index + 1],
      [0.5, 1, 0.5],
      Extrapolation.CLAMP
    );

    return {
      width: widthAnimation,
      opacity: opacityAnimation
    };
  });

  return (
    <Animated.View
      className="mx-2.5 h-2.5 rounded-full bg-primary"
      style={[animatedDotStyle]}
    />
  );
}

type PaginationProps = {
  dataLength: number;
  currentIndex: number;
};

export function OnboardingPagination({
  dataLength,
  currentIndex
}: PaginationProps) {
  const animatedIndex = useSharedValue(currentIndex);

  // Whenever currentIndex changes from the parent,
  // animate local shared value to the new index
  useEffect(() => {
    animatedIndex.value = withTiming(currentIndex, { duration: 100 });
  }, [currentIndex, animatedIndex]);

  return (
    <View className="h-10 flex-row items-center justify-center">
      {Array.from({ length: dataLength }).map((_, index) => (
        <PaginationComp
          key={`p-${index}`}
          index={index}
          animatedIndex={animatedIndex}
        />
      ))}
    </View>
  );
}
